var React = require('react');

function OpenFullscreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.286 64.286H0V100h35.714V85.714H14.286V64.286ZM0 35.714h14.286V14.286h21.428V0H0v35.714Zm85.714 50H64.286V100H100V64.286H85.714v21.428ZM64.286 0v14.286h21.428v21.428H100V0H64.286Z"}));
}

OpenFullscreen.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = OpenFullscreen;

OpenFullscreen.default = OpenFullscreen;
